import React from "react"
import "./CoreLoader.css";

interface CoreLoaderProps {
    enabled: boolean
    size: string;
    className: string;
}
export const CoreLoader = ({ enabled = true, size = "32px", className = "stroke-green-500" }: CoreLoaderProps) => {

    return (enabled && <div className="loader" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="loader circular" viewBox="25 25 50 50">
            <circle
                className={`path ${className}`}
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth="3"
                strokeMiterlimit="10" />
        </svg>

    </div>

    );
}



{/* <div class="loader" style="width:{size}px; height:{size}px;">
    {#if enabled}
    <svg class="circular" viewBox="25 25 50 50">
        <circle
            class="path"
            stroke={color}
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="3"
            stroke-miter-limit="10" />
    </svg>
    {/if}

</div> */}
